import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { useLocales } from '../../../../../hooks';
import { toTitleCase } from '../../../../../utils/textUtils';
import Localized from '../../../../shared/Localized';
import UIModuleListItem, { IBaseUIModuleListItemProps } from '../../UIModuleListItem';
import { ShortNovelasClipsUiModuleBody } from '../../../../../API';

export type ShortNovelasClipsListItemProps = IBaseUIModuleListItemProps<ShortNovelasClipsUiModuleBody>;

export const testIds = {
  treatment: 'short-novelas-clips-list-item.treatment',
  source: 'short-novelas-clips-list-item.source',
  copy: 'short-novelas-clips-list-item.copy',
  ctaText: 'short-novelas-clips-list-item.ctaText'
};

const ShortNovelasClipsListItem = ({ uiModule, ...props }: ShortNovelasClipsListItemProps): JSX.Element => {
  const { t } = useLocales();

  const Title = () => {
    return <Localized prop={uiModule.title} />;
  };

  return (
    <UIModuleListItem
      uiModule={uiModule}
      topLineTitle={<Title />}
      topLine={[
        <Box key="treatment" display="flex" alignItems="center" gap={2}>
          <Box key="treatment" display="flex" alignItems="center" gap={1}>
            <Typography variant="body2" color="textSecondary">
              {t('layouts.short_novelas_clips.fields.copy')}:
            </Typography>
            <Chip label={toTitleCase(uiModule.copy)} size="small" data-testid={testIds.copy} />
          </Box>
          <Box key="treatment" display="flex" alignItems="center" gap={1}>
            <Typography variant="body2" color="textSecondary">
              {t('layouts.short_novelas_clips.fields.ctaText')}:
            </Typography>
            <Chip label={toTitleCase(uiModule.ctaText)} size="small" data-testid={testIds.ctaText} />
          </Box>
        </Box>
      ]}
      {...props}
    />
  );
};

export default ShortNovelasClipsListItem;
